import { render, staticRenderFns } from "./NewBrandingModal.vue?vue&type=template&id=3261f0eb&scoped=true"
import script from "./NewBrandingModal.vue?vue&type=script&lang=js"
export * from "./NewBrandingModal.vue?vue&type=script&lang=js"
import style0 from "./NewBrandingModal.vue?vue&type=style&index=0&id=3261f0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261f0eb",
  null
  
)

export default component.exports